import React, { useLayoutEffect } from 'react'
import ReactGA from 'react-ga'
import { ScrollView, View, StatusBar, SafeAreaView, Platform } from 'react-native'
import CollapseCard from './components/CollapseCard'
import { Txt, IconButton, Spinner } from '../../components'
import { useNavigation } from '@react-navigation/native'
import { usePlatforms } from '../../hooks/usePlatforms'
import ParticlesBackground from '../../components/ParticlesBackground'
import { faqsSelector } from '../../redux/faqs/faqsSelector'
import { useDispatch, useSelector } from 'react-redux'
import { getFaqs } from '../../redux/faqs/faqsActions'

ReactGA.pageview('/main/faqs')

const FAQs = () => {
  const dispatch = useDispatch()
  const navigation = useNavigation()
  const { isTablet } = usePlatforms()
  const { faqs, loading } = useSelector(faqsSelector)

  const onGoBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.navigate('main', { screen: 'dashboard' })
    }
  }

  useLayoutEffect(() => {
    dispatch(getFaqs())
  }, [dispatch])

  return (
    <ScrollView style={{ flex: 1 }}>
      <StatusBar barStyle='dark-content' color='blue' />

      <View style={{ width: '100%', height: 150 }}>
        <ParticlesBackground>
          <SafeAreaView />
          <View style={{ flex: 1, paddingHorizontal: 10, paddingTop: Platform.OS === 'web' ? 20 : 0 }}>
            {!isTablet && (
              <IconButton
                icon='LeftArrow'
                onPress={onGoBack}
                color='CATSKILL_WHITE'
                iconColor='BUNKER'
                size={30}
                iconSize={16}
              />
            )}
            <Txt text='Capacity FAQS' identity='h2' color='WHITE_TEXT' style={{ marginTop: 20 }} />
          </View>
        </ParticlesBackground>
      </View>
      {/* <Txt text='Questions' identity='h2' style={{ margin: 10 }} /> */}
      <View style={{ width: '100%', maxWidth: 800, marginHorizontal: 'auto', marginVertical: 10 }}>
        {loading ? <Spinner /> : faqs.map((question, key) => <CollapseCard question={question} key={key} />)}
      </View>
    </ScrollView>
  )
}

export default FAQs
